// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Mp-z","imageAndVideoCount":"Np-z","imageAndVideoContainer":"Op-z","viewAllReviews":"Pp-z"};